import CONSTS from './constants';

export default () => {
  let Env = {};
  switch (process.env.REACT_APP_ENV) {
    case CONSTS.ENV.PROD:
      Env = {
        api: {
          name: process.env.REACT_APP_NAME,
          env: process.env.REACT_APP_ENV,
          network: {
            url: process.env.REACT_APP_PROD_PROXY_URL,
          },
        },
        app: {
          version: process.env.REACT_APP_PROD_APP_API_VERSION,
        },
        webSocket: {
          network: {
            url: process.env.REACT_APP_PROD_WEB_SOCKET_URL,
          },
        },
        webpay: {
          url: process.env.REACT_APP_WEBPAY_RETURN_URL,
        },
        key: process.env.REACT_APP_CRYPTO_KEY,
        faqs: process.env.FAQS_URL
      };
      break;
    case CONSTS.ENV.DEV:
      Env = {
        api: {
          name: process.env.REACT_APP_NAME,
          env: process.env.REACT_APP_ENV,
          network: {
            url: process.env.REACT_APP_DEV_PROXY_URL,
          },
        },
        app: {
          version: process.env.REACT_APP_DEV_APP_API_VERSION,
        },
        webSocket: {
          network: {
            url: process.env.REACT_APP_DEV_WEB_SOCKET_URL,
          },
        },
        webpay: {
          url: process.env.REACT_APP_WEBPAY_RETURN_URL,
        },
        key: process.env.REACT_APP_CRYPTO_KEY,
        faqs: process.env.FAQS_URL
      };
      break;
    default:
      Env = {
        api: {
          name: process.env.REACT_APP_NAME,
          env: process.env.REACT_APP_ENV,
          network: {
            url: process.env.REACT_APP_DEV_PROXY_URL,
          },
        },
        app: {
          version: process.env.REACT_APP_DEV_APP_API_VERSION,
        },
        webSocket: {
          network: {
            url: process.env.REACT_APP_DEV_WEB_SOCKET_URL,
          },
        },
        faqs: process.env.FAQS_URL
      };
      break;
  }
  return Env;
};
